import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const SettingsSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default SettingsSVG;
